import React from "react"

import { DNA, InfinitySpin } from 'react-loader-spinner'; // Example using react-spinners
import { myOwnFPColor } from "../App/GridRenderers";
import { Button } from "@mui/material";

export const Spinner = ({ isLoading }) => {
    if (!isLoading) return null;

    return (
        <div className="spinner-overlay">
            {/* <DNA
                color={myOwnFPColor}
            /> */}
            <InfinitySpin
                visible={true}
                width={150}
                color={myOwnFPColor}
            />
        </div>
    );
};

